import { Phone, Mail } from "lucide-react";
import instagramIcon from "/src/assets/icons/instagram.svg";

export function Footer() {
    return (
        <footer className="bg-slate-950 border-t border-brand-500/20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-3 gap-12 mb-12">
                    {/* Logo e descrição */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="w-10 h-10 bg-brand-400 rounded-lg flex items-center justify-center shadow-[0_0_20px_rgba(185,255,102,0.4)]">
                                <span className="text-slate-950 font-bold text-lg">G</span>
                            </div>
                            <div>
                                <h3 className="text-white font-bold text-xl">Agência Gens</h3>
                            </div>
                        </div>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            O único hub de{" "}
                            <span className="text-brand-400">marketing digital e tecnologia</span>{" "}
                            que qualquer clínica precisa para crescer.
                        </p>
                    </div>

                    {/* Suporte */}
                    <div>
                        <h4 className="text-brand-400 font-semibold mb-4">Suporte da Agência</h4>
                        <div className="space-y-3">
                            <a
                                href="#"
                                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                            >
                                <Phone className="w-4 h-4" />
                                Chamar no WhatsApp
                            </a>
                            <a
                                href="#"
                                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                            >
                                <Mail className="w-4 h-4" />
                                contato@agenciagens.com.br
                            </a>
                        </div>
                    </div>

                    {/* Redes Sociais */}
                    <div>
                        <h4 className="text-brand-400 font-semibold mb-4">Redes sociais</h4>
                        <div className="flex gap-3">
                            {/* X (Twitter) */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-slate-900 border border-brand-500/30 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-brand-400 hover:shadow-[0_0_15px_rgba(34,197,94,0.4)] transition-all duration-300"
                            >
                                X
                            </a>
                            {/* LinkedIn */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-slate-900 border border-brand-500/30 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-brand-400 hover:shadow-[0_0_15px_rgba(34,197,94,0.4)] transition-all duration-300"
                            >
                                in
                            </a>
                            {/* Instagram */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-slate-900 border border-brand-500/30 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-brand-400 hover:shadow-[0_0_15px_rgba(34,197,94,0.4)] transition-all duration-300 group"
                            >
                                <img src={instagramIcon} alt="Instagram" className="w-5 h-5 opacity-60 group-hover:opacity-100 transition-opacity" />
                            </a>
                            {/* YouTube */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-slate-900 border border-brand-500/30 rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:border-brand-400 hover:shadow-[0_0_15px_rgba(34,197,94,0.4)] transition-all duration-300"
                            >
                                YT
                            </a>
                        </div>
                    </div>
                </div>

                {/* Linha divisória */}
                <div className="border-t border-brand-500/20 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <div className="flex gap-6 text-sm">
                            <a href="#" className="text-slate-500 hover:text-brand-400 transition-colors">
                                Termos de uso
                            </a>
                            <a href="#" className="text-slate-500 hover:text-brand-400 transition-colors">
                                Políticas de Privacidade
                            </a>
                        </div>
                        <p className="text-slate-500 text-sm">
                            Copyright Agência Gens {new Date().getFullYear()} © Todos os direitos reservados
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
